import { Link } from 'react-router-dom';
import { hotMovies } from '@/mocks/homeData';

export default function HotMoviesSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              热门推荐
            </h2>
            <p className="text-foreground-500 text-sm">精选高分影视，大家都在看</p>
          </div>
          <Link
            to="/category/dianying"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
          {hotMovies.map((movie) => (
            <Link
              key={movie.id}
              to={`/category/${movie.category}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden mb-3">
                <img
                  src={movie.image}
                  alt={movie.title}
                  title={`${movie.title} - 红桃影视高清在线观看`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
                    {movie.rating}
                  </span>
                </div>
                <div className="absolute bottom-3 left-3 right-3">
                  <span className="text-xs text-background-200/80 bg-black/40 px-2 py-0.5 rounded-full">
                    {movie.categoryName} · {movie.year}
                  </span>
                </div>
              </div>
              <h3 className="font-medium text-sm text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                {movie.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1 line-clamp-2 leading-relaxed">
                {movie.description}
              </p>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/dianying"
            className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium cursor-pointer"
          >
            查看全部推荐
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}